import { useCallback, useRef } from "react";
import { _ROUTES } from "../../../utils/_routes_constants";
import { _ACTIONS } from "../../../utils/constants";
import { createToast, createToastOnLastItemSaved } from "../../../utils/toast";
import { DIESEL_IMPACT, TOTAL_COST_RS_T } from "./AgGridQuarryingExcavator";
import { DataService } from "../../../services/DataService";

/**
 * Hook pour gérer les mises à jour des cellules Ag-Grid avec PATCH/POST
 * @param {Object} params - Contient site, fiscalYear, et version
 * @param {Function} setPendingRefresh - Fonction pour rafraîchir les données après modification
 * @returns {Function} Callback pour gérer les changements de cellule
 */
export function useSalesOnCellValueChanged(params, setPendingRefresh, gridRef) {
  const dataService = new DataService();
  const pendingUpdatesRef = useRef(0);

  return useCallback(
    async (agParams) => {
      const { colDef, data, newValue, api } = agParams;
      const { site, fiscalYear, version } = params;

      const fiscalMonth = parseInt(colDef.field);

      if (!site || !fiscalYear || !version) {
        createToast(
          "warning",
          "Données manquantes ou invalides. Vérifiez votre saisie.",
        );
        return;
      }

      const action = _ACTIONS.POST;
      const url = _ROUTES.SAVE_INPUT_SALE_QUARRYING;
      let payload = null;

      const isRateChange = colDef.field === "rate";
      const isDieselImpact = data.subThemes === DIESEL_IMPACT;

      switch (true) {
        case isRateChange:
          payload = {
            fiscalYear,
            version: version || 1,
            site: site,
            theme: data.theme,
            source: data.subThemes,
            rateIncrease: parseFloat(newValue),
          };

          break;

        case isDieselImpact:
          payload = {
            fiscalYear,
            version: version || 1,
            fiscalMonth: parseInt(colDef.field),
            site: site,
            theme: data.theme,
            source: data.subThemes,
            value: parseFloat(newValue),
          };

          break;

        /**
         * @info default case is forse save input sale quarrying month
         */
        default:
          payload = {
            site: site,
            fiscalMonth,
            fiscalYear,
            version: version || 1,
            amount: parseFloat(newValue),
            source: data.subThemes,
            theme: data.theme,
          };

          break;
      }

      pendingUpdatesRef.current++;

      dataService
        .doRequest(action, url, payload, {}, (params) => {})
        .finally(() => {
          pendingUpdatesRef.current--;

          api.refreshCells({
            force: true,
          });

          if (pendingUpdatesRef.current === 0) {
            setPendingRefresh((prev) => !prev);

            /******************************************************************************
             * THIS PART IS FOR SAVE ROWS WHICH BELING TO " TOTAL COST RS/T " THEME AND IS USEFULL IN TURNOVER LRL
             *****************************************************************************/

            /** @var totalCost get total cost rs/t theme whith each sub-theme */
            const totalCost = [];

            api.forEachLeafNode((node) => {
              if (node.data?.theme === TOTAL_COST_RS_T) {
                totalCost.push(node.data);
              }
            });

            dataService.doRequest(
              _ACTIONS.POST,
              _ROUTES.SAVE_TOTAL_COST_QUARRYING,
              {
                totalCost,
                fiscalYear,
                version: version || 1,
                site: site,
              },
            );

            /******************************************************************************
             * END SECTION: SAVE TOTAL COST RS/T
             *****************************************************************************/

            createToastOnLastItemSaved(pendingUpdatesRef);
          }
        });
    },
    [params, setPendingRefresh],
  );
}
